import React from 'react'
import { Box, CircularProgress, Typography, Paper } from '@mui/material'

const LoadingPage = ({ message = 'Yükleniyor...' }) => {
  return (
    <Box
      className="loading-page"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          padding: 4,
          borderRadius: 3,
          textAlign: 'center',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <img
            src="/logo.svg"
            SafeLine Admin Panel
            style={{ width: 64, height: 64 }}
            onError={(e) => {
              e.target.style.display = 'none'
            }}
          />
        </Box>

        <CircularProgress
          size={50}
          thickness={4}
          sx={{
            color: '#667eea',
            mb: 2
          }}
        />

        <Typography
          variant="h6"
          sx={{
            color: '#333',
            fontWeight: 500,
            mb: 1
          }}
        >
          VirtualSMS Admin Panel
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: '#666',
            fontWeight: 400
          }}
        >
          {message}
        </Typography>
      </Paper>
    </Box>
  )
}

export default LoadingPage